import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as FacilitiesActions from '../../actions/facilities_actions';
import { bindActionCreators } from 'redux';
import ChangePassword from './changePassword';
import ProfileSetting from './profileSetting';
import UpdateSecurityQuestions from './updateSecurityQuestions';
import Header from '../../components/header';
import PasswordToProceedModal from '../../components/passwordToProceedModal'
let screenIdentifier = 'settingsScreen';

import * as SettingScreen from '../../actions/settingScreen_actions';

let SettingsScreen = React.createClass({
    getInitialState() {
        return {
            selectedTab: '0',
            previouslySelectedTab: '0',
            showPasswordToProceeedModal: false,
        }
    },
    componentWillReceiveProps(nextProps) {

    },
    componentWillMount() {
        this.props.Dispatch(SettingScreen.resetOTPData());

        let fc_id = this.props.UserDetails.selectedUserRoleID === 1 ? 0 : this.props.UserDetails.selectdUserFacilityID;

        this.props.Dispatch(FacilitiesActions.getAdminUserById(this.props.LogingDetails.data.id + "/" + fc_id));
        this.props.Dispatch(SettingScreen.getAllSecurityQuestions());
        this.props.Dispatch(SettingScreen.getsecurityAnswers());
    },
    componentDidMount() {

    },
    storeTypeHandler(e) {
        this.props.Dispatch(SettingScreen.resetOTPData());

        let fc_id = this.props.UserDetails.selectedUserRoleID === 1 ? 0 : this.props.UserDetails.selectdUserFacilityID;
        this.props.Dispatch(FacilitiesActions.getAdminUserById(this.props.LogingDetails.data.id + "/" + fc_id));
        this.props.Dispatch(SettingScreen.getsecurityAnswers());
        if (this.state.previouslySelectedTab !== 2 && e.target.value === '2') {
            this.setState({ showPasswordToProceeedModal: true });
            return;
        }

        if (e.target.value !== '2') {
            this.setState({ showPasswordToProceeedModal: false });
            this.setState({ selectedTab: e.target.value, previouslySelectedTab: e.target.value });
        }
    },

    isPasswordVerified(isPasswordVerified) {
        if (isPasswordVerified) {
            this.setState({ selectedTab: '2', previouslySelectedTab: '2' });
            this.setState({ showPasswordToProceeedModal: false });
        } else {
            this.setState({ showPasswordToProceeedModal: false });
        }
    },

    navigationHandler() {
    },
    render() {

        return (
            <div className="dashboard-inner-content">
                <Header screenIdentifier={screenIdentifier} />
                <div className="white-box questionnaire">
                    <ul className="nav nav-tabs" role="tablist">
                        <button onClick={this.storeTypeHandler} value='0'
                            className={(this.state.selectedTab === '0' ? 'button active' : 'button')}>profile settings</button>
                        <button onClick={this.storeTypeHandler} value='1'
                            className={(this.state.selectedTab === '1' ? 'button active' : 'button')}>change password</button>
                        <button onClick={this.storeTypeHandler} value='2'
                            className={(this.state.selectedTab === '2' ? 'button active' : 'button')}>Update Security Questions</button>
                    </ul>

                    <div className="tab-content settings">
                        {(this.state.selectedTab === '0') && <ProfileSetting />}
                        {(this.state.selectedTab === '1') && <ChangePassword />}
                        {(this.state.selectedTab === '2') && <UpdateSecurityQuestions />}
                    </div>
                </div>
                {this.state.showPasswordToProceeedModal && <PasswordToProceedModal showPasswordToProceeed={this.state.showPasswordToProceeedModal} passwordVerified={this.isPasswordVerified} ></PasswordToProceedModal>}
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        UserDetails: state.User,
        LogingDetails: state.User.loginData,
    };
};

let mapDispatchToProps = (dispatch) => ({
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(SettingsScreen));



/** WEBPACK FOOTER **
 ** ./src/components/settingsScreen/settingsScreen.js
 **/